import { render, staticRenderFns } from "./CustomerComputersFormTable.vue?vue&type=template&id=3527375a"
import script from "./CustomerComputersFormTable.vue?vue&type=script&lang=js"
export * from "./CustomerComputersFormTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports